import React, { useEffect, useState } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Table, TableHead, TableBody } from "component/common/Table";
import Pagination from "component/common/Pagination";
import Moment from "react-moment";
import DeleteConfirmation from "component/common/DeleteConfirmation";
import Loader from "component/common/Loader";
import queryString from "query-string";
import eye from "assets/images/eye.svg";
import edit from "assets/images/edit.svg";
import dustbin from "assets/images/dustbin.svg";
import styles from "./PaymentList.module.scss";
import { Toast } from "utils/toast";
import PaymentFilter from "./PaymentFilter/PaymentFilter";
import SearchInput from "component/common/SearchInput";
import { deleteSellerById, getSellerList } from "service/Payment";
import { debounce } from "debounce";
import AddSeller from "./AddSeller";
import Notification from "component/NotifyComp";
import { AiOutlineBank } from "react-icons/ai";
import PaymentHistory from "./PaymentHistory";
import NormalButton from "component/common/NormalButton";
import { getRoleAction } from "utils/helper";

const PaymentList = () => {
  let location = useLocation();

  let history = useHistory();

  const { isOperationAvailable } = getRoleAction("Payments");

  const head = [
    // "Seller No",
    "Seller I'd",
    "Name",
    "Mobile Number",
    "Email",
    "Seller Product",
    "UPI ID/Bank account number",
    "Total Amount",
    "Payment Status",
    "",
  ];

  const page = new URLSearchParams(location.search).get("page");

  const sellerid = new URLSearchParams(location.search).get("sellerid");

  const sellername = new URLSearchParams(location.search).get("sellername");

  const upi = new URLSearchParams(location.search).get("upi");

  const mobile = new URLSearchParams(location.search).get("mobile");

  const email = new URLSearchParams(location.search).get("email");

  const product = new URLSearchParams(location.search).get("product");

  const amount = new URLSearchParams(location.search).get("amount");

  const sellerId_by_user = new URLSearchParams(location.search).get(
    "sellerId_by_user"
  );

  const paymentStatus = new URLSearchParams(location.search).get(
    "paymentStatus"
  );

  const common = new URLSearchParams(location.search).get("common");

  let [paymentsData, setPaymentsData] = useState();

  let [confirmation, setConfirmation] = useState(false);

  let [id, setId] = useState(null);
  let [totalPages, setTotalPages] = useState();
  let [showModal, setShowModal] = useState(false);
  let [editModal, setEditModal] = useState(false);

  const getSellerListData = async () => {
    let params = {
      page: page != null ? page : 1,
      sellerid: sellerid,
      sellerId_by_user: sellerId_by_user,
      sellername: sellername,
      upi: upi,
      mobile: mobile,
      email: email,
      product: product,
      amount: amount,
      paymentStatus: paymentStatus,
      common: common,
      limit: 5,
    };
    try {
      let response = await getSellerList(params);
      if (response.status == 200) {
        let temp = response?.data?.data?.data?.map((x) => {
          return { ...x, amount: Number(x?.amount) };
        });
        setPaymentsData(temp);
        setTotalPages(response?.data?.data?.pageMeta?.totalPages);
      }
    } catch (error) {
      // Toast({ type: "error", message: error.data.message });
    }
  };

  const handleHistory = () => {
    history.push(`/admin/payments/payment-history`);
  };

  const handlePageChange = async (event) => {
    let params = queryString.stringify({
      sellerid: sellerid ? sellerid : undefined,
      sellerId_by_user: sellerId_by_user ? sellerId_by_user : undefined,
      sellername: sellername ? sellername : undefined,
      upi: upi ? upi : undefined,
      mobile: mobile ? mobile : undefined,
      email: email ? email : undefined,
      product: product ? product : undefined,
      amount: amount ? amount : undefined,
      paymentStatus: paymentStatus ? paymentStatus : undefined,
      common: common ? common : undefined,
      limit: 5,
    });
    if (params == "") {
      history.push(`/admin/payments/list?page=${event}`);
    } else {
      history.push(`/admin/payments/list?${params}&page=${event}`);
    }
  };

  const onDelete = async () => {
    try {
      let body = {
        sellerId_by_user: id,
      };
      let response = await deleteSellerById(body);
      if (response) {
        toggleConfirmation();
        Toast({
          type: "success",
          message: "Seller has been deleted successfully",
        });
        getSellerListData();
        setId(id);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const toggleConfirmation = () => {
    setConfirmation(!confirmation);
  };

  const showConfirmation = (id) => {
    setId(id);
    toggleConfirmation();
  };

  const showModalFunc = (data, editTrue, id) => {
    setShowModal(data);
    if (editTrue) {
      setId(id);
      setEditModal(true);
    }
  };

  const handleSearch = (event) => {
    let params = queryString.stringify({
      common: event == "" ? undefined : event,
    });
    if (queryString.stringify(params).length == 0) {
      history.push(`/admin/payments/list`);
    } else {
      history.push(`/admin/payments/list?${params}`);
    }
  };

  useEffect(() => {
    getSellerListData();
  }, [location.search]);

  if (paymentsData == null) return <Loader />;

  return (
    <>
      <div className="row mb-2">
        <div className="col-md-6">
          <div className={styles.donation_title}>
            <b>Payments</b>
          </div>
        </div>
        <div className="col-md-6 d-flex justify-content-end align-items-center mt-2">
          <div className={styles.search}>
            <SearchInput
              placeholder="Search"
              onChange={debounce(handleSearch, 500)}
              onSearch={() => alert("search")}
            />
          </div>
          {isOperationAvailable("Payment History") && (
            <div className="mr-3">
              <NormalButton label="Payment History" onClick={handleHistory} />
            </div>
          )}

          {isOperationAvailable("Add Seller") && (
            <AddSeller
              getSellerListData={getSellerListData}
              showModal={showModal}
              showModalData={(data) => showModalFunc(data)}
              editModal={editModal}
              viewPage={false}
              id={id}
              setEditModal={setEditModal}
            />
          )}
        </div>
      </div>
      <Table>
        <TableHead className={styles.donation_head} head={head} />
        <TableBody>
          <PaymentFilter page="payments" />
          {paymentsData?.length > 0 ? (
            paymentsData?.map((list, index) => {
              return (
                <tr
                  key={index}
                  className={styles.donation_body}
                  style={{ verticalAlign: "center" }}
                >
                  <td>
                    {!list?.sellerId_by_user ? "-" : list?.sellerId_by_user}
                  </td>
                  <td>{!!list?.sellerName ? list?.sellerName : "-"}</td>
                  <td>{!!list?.mobileNo ? list?.mobileNo : "-"}</td>
                  <td>{!!list?.emailId ? list?.emailId : "-"}</td>
                  <td>
                    {list?.sellerProduct.length ? (
                      list?.sellerProduct?.length > 1 ? (
                        list.sellerProduct.slice(0, 2).join(",")
                      ) : (
                        <>{list?.sellerProduct}</>
                      )
                    ) : (
                      "-"
                    )}
                    {list?.sellerProduct?.length > 2 && (
                      <>
                        <div className={styles.hover_product}>
                          + {list.sellerProduct?.length - 2}
                          <div className={styles.hover_product_text}>
                            {list.sellerProduct.map((val) => {
                              return <label className="d-block">{val}</label>;
                            })}
                          </div>
                        </div>
                      </>
                    )}
                  </td>
                  {console.log("list", list?.UPICode)}

                  {list?.bankDetails.accountNumber == "" ? (
                    <div>
                      {list?.UPICode?.map((item) => (
                        <td className={styles.overflow_any}>{item?.upi}</td>
                      ))}
                    </div>
                  ) : (
                    <div>
                      <td className={styles.overflow_any}>
                        {list?.bankDetails.accountNumber}
                      </td>
                    </div>
                  )}

                  <td>{!!list.amount ? list.amount : 0}</td>
                  <td className="text-capitalize">{list?.paymentStatus}</td>
                  <td>
                    <UncontrolledDropdown>
                      <DropdownToggle tag="span" data-toggle="dropdown">
                        <i className="icon-dots"></i>
                      </DropdownToggle>
                      <DropdownMenu>
                        {isOperationAvailable("View") && (
                          <Link
                            to={`/admin/payments/viewpayments/${list?.sellerId_by_user}`}
                          >
                            <DropdownItem>
                              <div className="dropdown-items">
                                <img src={eye} alt="view" />
                                <span>View</span>
                              </div>
                            </DropdownItem>
                          </Link>
                        )}
                        {isOperationAvailable("Edit") && (
                          <DropdownItem
                            onClick={() =>
                              showModalFunc(
                                true,
                                "editTrue",
                                list?.sellerId_by_user
                              )
                            }
                          >
                            <div className="dropdown-items">
                              <img src={edit} alt="edit" />
                              <span>Edit</span>
                            </div>
                          </DropdownItem>
                        )}
                        {isOperationAvailable("Delete") && (
                          <DropdownItem
                            onClick={() =>
                              showConfirmation(list?.sellerId_by_user)
                            }
                          >
                            <div className="dropdown-items">
                              <img src={dustbin} alt="delete" />
                              <span>Delete</span>
                            </div>
                          </DropdownItem>
                        )}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="9" className="no-record">
                No Records Found
              </td>
            </tr>
          )}
        </TableBody>
      </Table>
      {totalPages > 1 && (
        <Pagination
          totalPages={totalPages}
          activePage={page != null ? page : 1}
          onPageChange={handlePageChange}
        />
      )}
      <DeleteConfirmation
        message="Are you sure to delete this seller?"
        isOpen={confirmation}
        toggle={toggleConfirmation}
        onSubmit={onDelete}
      />
    </>
  );
};

export default PaymentList;
